import React from 'react'
import {Button, Tooltip} from 'antd'
import {DownloadOutlined} from '@ant-design/icons'
import PropTypes from 'prop-types'
import useExport from "../hooks/useExport";

const GenericExportButton = (props) => {
    const {
        apiFunction,
        buttonText,
        fileName = 'export.xlsx',
        filters,
        tenants,
        level,
        needsLevel = true,
        needsTenantName = true,
        className = 'export-btn',
        buttonType = 'primary',
        icon = <DownloadOutlined/>,
        disabled = false,
        customPayload = {},
        onSuccess,
        onError,
        tooltip = '',
        isBreakDisabled
    } = props

    const {loading, handleExport} = useExport(apiFunction, {
        needsLevel,
        needsTenantName,
        fileName,
        onSuccess,
        onError
    })

    const onExport = () => {
        if ((!filters.tenantId || filters.tenantId.length === 0) && !isBreakDisabled) {
            return
        }

        handleExport(filters, tenants, level, customPayload)
    }

    const isDisabled = disabled || !filters.tenantId || filters.tenantId.length === 0

    const button = (
        <Button
            className={className}
            type={buttonType}
            loading={loading}
            onClick={onExport}
            disabled={!isBreakDisabled ? isDisabled : false}
            icon={icon}
            block
        >
            {buttonText}
        </Button>
    )

    if (isDisabled && !loading) {
        return (
            <Tooltip title={tooltip || "Vui lòng chọn khách hàng trước khi export"}>
                {button}
            </Tooltip>
        )
    }

    return button
}

GenericExportButton.propTypes = {
    apiFunction: PropTypes.func.isRequired,
    buttonText: PropTypes.string.isRequired,
    fileName: PropTypes.string,
    filters: PropTypes.object.isRequired,
    tenants: PropTypes.array.isRequired,
    level: PropTypes.any,
    needsLevel: PropTypes.bool,
    needsTenantName: PropTypes.bool,
    className: PropTypes.string,
    buttonType: PropTypes.string,
    icon: PropTypes.node,
    disabled: PropTypes.bool,
    customPayload: PropTypes.object,
    onSuccess: PropTypes.func,
    onError: PropTypes.func,
    tooltip: PropTypes.string
}

export default GenericExportButton